import {Component, h} from "preact";
import styles from './style.module.scss';
import {Image, Product, Variant} from "../../models/product";
import {productService} from "../../services/product-service";
import ProductItem from "../product-item";
import {connect} from "redux-zero/preact";
import {withDeviceIndicator} from "../../hoc/withDeviceIndicator";
import {NY_Tracker, TrackingEvent} from "../../services/tracking-service";
import {i18nService} from "../../services/i18n-service";
import {navigationService} from "../../services/navigation-service";

interface Props {
  productId: string;
  variantId: string;
  isMobile?: boolean;
}

interface State {
  matchingProducts: Product[]
}

class MatchingProducts extends Component<Props, State> {

  state = {
    matchingProducts: []
  };

  async componentDidMount() {
    return this.loadMatchingProducts(this.props.productId, this.props.variantId);
  }

  async componentWillReceiveProps(nextProps: Props) {
    if (nextProps.productId != this.props.productId || nextProps.variantId != this.props.variantId) {
      return this.loadMatchingProducts(nextProps.productId, nextProps.variantId);
    }
  }

  async loadMatchingProducts(productId: string, variantId: string) {
    let products = await productService.loadMatchingProducts(productId, variantId, 6);
    this.trackIfMatchingProductsAvailable(products);
    this.setState({matchingProducts: products});
  }

  handleClick(variant: Variant) {
    window.scrollTo({left: 0, top: 0, behavior: 'smooth'});
    const imageContainer = document.querySelector('.image-scroll-snap-container');
    if (imageContainer) {
      imageContainer.scrollTo({left: 0, top: 0, behavior: 'smooth'});
    }

    const detailContainer = document.querySelector('.detail-scroll-snap-container');
    if (detailContainer) {
      detailContainer.scrollTo({left: 0, top: 0, behavior: 'smooth'});
    }
    let event = {
      label: `${variant.productId} - ${variant.id}`,
      action: 'selectMatchingProduct',
      category: 'Products',
      isSale: variant.sale ? '1' : '0',
      imageType: (variant.images.find(i => i.position === 0) as Image)?.type
    };

    NY_Tracker.trackClick(event as TrackingEvent);
    navigationService.showDetailView(variant.productId, variant.id);
  }

  trackIfMatchingProductsAvailable(products: Product[]) {
    if (products.length > 0) {
      let event = {
        label: `${this.props.productId} - ${this.props.variantId}`,
        action: 'matchingProductsAvailable',
        category: 'Products'
      };
      NY_Tracker.trackClick(event as TrackingEvent);
    }
  }

  render() {
    if (!(this.state.matchingProducts && this.state.matchingProducts.length > 0)) {
      return (
        <div class={styles['matching-products']}>
          <div class={styles['fill-container']}/>
        </div>
      )
    }

    if (this.props.isMobile) {
      return (
        <div class={styles['matching-products']}>
          <div class={styles['headline']}>{i18nService.translate('detail_view_complete_your_look')}</div>
          <div id={'detail-match-products-scroll-container'} class={styles['slider']}>
            {this.state.matchingProducts.map(product => {
              return (
                <div class={styles['product']}>
                  <ProductItem scrollContainer={'#detail-match-products-scroll-container'}
                               product={product} clickCallback={this.handleClick} resolution={'mid'}
                               dimension={'MatchingProducts'}/>
                </div>
              )
            })}
          </div>
        </div>
      )
    }
    const hiddenContainersCount = 3 - (this.state.matchingProducts.length % 3);
    return (
      <div class={styles['matching-products']}>
        <div class={styles['headline']}>{i18nService.translate('detail_view_complete_your_look')}</div>
        <div class={styles['products']}>
          {this.state.matchingProducts.map(product => {
            return (
              <div class={styles['product']}>
                <ProductItem product={product} clickCallback={this.handleClick} resolution={'high'}
                             dimension={'MatchingProducts'}/>
              </div>
            )
          })}

          {Array.apply(null, {length: hiddenContainersCount}).map(() =>
            <div class={`${styles.product} ${styles.hidden}`}/>
          )}
        </div>
      </div>
    )
  }
}

export default connect(null, null,)(withDeviceIndicator(MatchingProducts))